import { useEffect } from "react";
import { resolveVisitorId } from "../utils/visitorId";

// Tags every page's GA hits with the GrowthBook visitor id, including pages that
// don't load GrowthBook (see experiments/withGrowthBook.tsx).
export function useGbuuidUserProperty() {
  useEffect(() => {
    const visitorId = resolveVisitorId();

    if (typeof window.gtag === "function") {
      window.gtag("set", "user_properties", { gbuuid: visitorId });
    }
  }, []);
}
